<template>
    <v-snackbar
        v-model="isVisible"
        :timeout="timeout"
        :color="color"
        elevation="0"
        transition="slide-y-reverse-transition"
    >
        {{ text }}
        <template v-slot:action="{ attrs }">
            <v-btn
                text
                v-bind="attrs"
                @click="isVisible = false"
            >
                Sluiten
            </v-btn>
        </template>
    </v-snackbar>

</template>

<script>
export default {
    name: "Snackbar",
    computed: {
        isVisible: {
            get() {
                return this.$store.state.app.snackbar.visible
            },
            set() {
                return this.$store.commit('HIDE_SNACKBAR');
            }
        },
        text() {
            return this.$store.state.app.snackbar.text;
        },
        timeout() {
            return this.$store.state.app.snackbar.timeout;
        },
        color() {
            return this.$store.state.app.snackbar.color;
        }
    }

}
</script>

<style>
.v-snack {
    z-index: 3 !important;
}
.v-snack .v-snack__wrapper {
    width: 100%;
    margin: 0;
    border-radius: 0 !important;
}
</style>
